import { render, staticRenderFns } from "./Colaboradores.vue?vue&type=template&id=50546264&scoped=true&"
import script from "./Colaboradores.vue?vue&type=script&lang=js&"
export * from "./Colaboradores.vue?vue&type=script&lang=js&"
import style0 from "./Colaboradores.vue?vue&type=style&index=0&id=50546264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50546264",
  null
  
)

export default component.exports